import { REALITY_CHECK } from '@ezugi/constants';

import { socketActions, dialogActions, videoActions } from '../../actions';
import { REGULATIONS_DIALOG, UKGC_DIALOG } from '../../constants/dialog';
import {
  notificationTypes,
  ukgcNotifications,
} from '../../constants/regulations';

const { socket } = socketActions;
const { dialog } = dialogActions;
const { video } = videoActions;

type RegulationData = {
  type: string;
}

export const getRegulationsActions = (data: RegulationData) => {
  const { type } = data;
  const actions: any = [];

  if (ukgcNotifications.includes(type)) {
    actions.push(dialog.add({ name: UKGC_DIALOG, data }));

    if (type !== REALITY_CHECK) {
      actions.push(socket.close(), video.shouldStop());
    }
    return actions;
  }

  if (notificationTypes.includes(type)) {
    actions.push(dialog.add({ name: REGULATIONS_DIALOG, data }));
    return actions;
  }

  return actions;
};
